import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDecisionNodeAtPath, isLoadingUnique } from '../../../../extractFromState';
import Loading, { LoadingWrapper } from '../../../LoadingComponent/LoadingComponent';
import { BackButton, NextButton } from '../../../common/buttonsComponents';
import { returnToPreviousMacroWizardPath } from '../../../../actions/searchActions';
import DecisionTreeInfoWidget from '../../DTInfoWidget/DTInfoWidget';
import { TopContainer, InfoWrapper } from './DTSelectedItemTransaction.styles';
import { ActionsButtonsWrapper } from '../../DecisionTree.styles';

const DTSelectedItemTransactionView = ({
  children,
  nextButtonClickHandler,
  nextButtonLabel = 'Next',
  isNextEnabled = true,
  showContainer = false,
}) => {
  const dispatch = useDispatch();
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const isLoading = useSelector(
    (state) =>
      (state.ui.loading.isLoading && state.ui.loading.component === 'itemTransactionContainer') ||
      isLoadingUnique(state, 'itemTransactionContainer')
  );

  return (
    <>
      {isLoading && (
        <LoadingWrapper>
          <Loading delay={0} />
        </LoadingWrapper>
      )}

      {!isLoading && showContainer && (
        <TopContainer>
          <InfoWrapper>{!!decisionNode.infoWidget && <DecisionTreeInfoWidget />}</InfoWrapper>
          {children}
          <ActionsButtonsWrapper>
            <NextButton disabled={!isNextEnabled} active={isNextEnabled} type="submit" onClick={nextButtonClickHandler}>
              {nextButtonLabel}
            </NextButton>
            <BackButton onClick={() => dispatch(returnToPreviousMacroWizardPath())}>BACK</BackButton>
          </ActionsButtonsWrapper>
        </TopContainer>
      )}
    </>
  );
};

export default DTSelectedItemTransactionView;
